module.exports = __webpack_public_path__ + "img/fail.35fa7ee0.jpg";